import { Box, Typography } from "@mui/material";
import DoNotDisturbOnIcon from "@mui/icons-material/DoNotDisturbOn";

function Unauthorized({ children }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50%",
        flexDirection: "column",
        px: 3,
      }}>
      <Box sx={{ my: 4 }}>
        <DoNotDisturbOnIcon sx={{ fontSize: 80 }} color={"error"} />
      </Box>
      <Typography variant={"h5"}>{children}</Typography>
    </Box>
  );
}

export default Unauthorized;
